import { AccountingFormTypes } from "models/formTypes";
import React from "react";
import { useAccountService } from "serviceHooks";
import { WintSuperkollAPIModelAccounting, WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";
import TransactionsAmount from "../transactionsAmount";
import { FinancialReportHelper } from "utils/helpers";

function useTransactionAmount(
  filter?: AccountingFormTypes.FinancialReportDateFilter,
  negateAmount?: boolean,
  currency?: string,
  isAudit?: boolean
) {
  const accountService = useAccountService();
  const [accounts, setAccounts] = React.useState<WintSuperkollAPIModelAccounting.Account[]>([]);

  React.useEffect(() => {
    accountService.getAccounts({} as WintSuperkollAPIModelAccounting.AccountFilter).then((res) => {
      setAccounts(res?.items ?? []);
    });
  }, []);

  const transactionAmountFormatter = (
    row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn,
    rowIndex: number,
    depth?: number,
    repeatIndex?: number,
    parentRow?: WintSuperkollAPIModelFinancialReport.FinancialReportRow
  ) => {
    const account = accounts.find((ac) => ac.id === parentRow?.id);
    let dateRange;

    if (filter?.columns) {
      repeatIndex = repeatIndex ?? 0;
      if (filter.columns.length > repeatIndex) {
        dateRange = filter.columns[repeatIndex].range;
      }
    }

    return (
      <TransactionsAmount
        amount={negateAmount ? (row.amount ? row.amount * -1 : row.amount) : row.amount}
        currency={currency}
        categoryName={parentRow?.description}
        categoryId={FinancialReportHelper.getCategoryId(parentRow)}
        isAccount={parentRow?.isAccount}
        accountNumber={parentRow?.isAccount && account ? account.number : undefined}
        accountId={parentRow?.isAccount ? parentRow.id : undefined}
        dateRange={dateRange}
        isAudit={isAudit}
      />
    );
  };

  return { transactionAmountFormatter };
}

export default useTransactionAmount;
